import React, { useState } from "react";
import { Button, Typography, Alert } from "@mui/material";
import APIURL from "../api/apiClient";

const UpdateItems = () => {
  const [file, setFile] = useState(null); // store file
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState([]);
  const [noChanges, setNoChanges] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Store selected file
  const handleFileSelect = (e) => {
    setFile(e.target.files[0]);
    // Clear previous messages
    setMessage("");
    setErrors([]);
    setNoChanges([]);
  };

  // Call API on button click
  const handleUpdate = async () => {
    if (!file) {
      setMessage("Please select a CSV file to update.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsLoading(true);
    setMessage("");
    setErrors([]);
    setNoChanges([]);

    try {
      const res = await fetch(
        `${APIURL.baseURL.replace("/api", "")}/import_excel/updateitems.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();

      setMessage(data.message || "Update complete.");
      setIsLoading(false);

      if (data.errors && data.errors.length > 0) {
        // Separate “No change detected” from others
        const noChange = data.errors.filter((e) =>
          e.error.includes("No change detected")
        );
        const otherErr = data.errors.filter(
          (e) => !e.error.includes("No change detected")
        );

        setNoChanges(noChange);
        setErrors(otherErr);
      }
    } catch (error) {
      console.error("Update failed:", error);
      setMessage("File upload failed. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h4>Excel Update Items</h4>
            </div>

            <div className="card-body">
              <form>
                <input
                  type="file"
                  name="import_file"
                  accept=".xls,.csv,.xlsx"
                  onChange={handleFileSelect}
                  className="form-control"
                />

                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={handleUpdate} // call API on button click
                  disabled={isLoading}
                >
                  {isLoading ? "Updating..." : "Update"}
                </Button>

                {/* ✅ Response message */}
                {message && (
                  <Alert
                    severity={
                      message.toLowerCase().includes("failed") ? "error" : "info"
                    }
                    sx={{ mt: 2 }}
                  >
                    {message}
                  </Alert>
                )}

                {/* ⚠️ Errors container */}
                {errors.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <Typography variant="h6" color="error">
                      ⚠️ Validation / Update Errors
                    </Typography>
                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #f5c6cb",
                        backgroundColor: "#f8d7da",
                        padding: "10px",
                        borderRadius: "5px",
                        marginTop: "8px",
                      }}
                    >
                      <ul style={{ margin: 0, paddingLeft: "18px" }}>
                        {errors.map((err, idx) => (
                          <li key={idx}>
                            Row {err.row}: {err.error}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {/* 🟢 No change detected container */}
                {noChanges.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <Typography variant="h6" color="textSecondary">
                      ℹ️ No Change Detected
                    </Typography>
                    <div
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        border: "1px solid #d6d8d9",
                        backgroundColor: "#e2e3e5",
                        padding: "10px",
                        borderRadius: "5px",
                        marginTop: "8px",
                      }}
                    >
                      <ul style={{ margin: 0, paddingLeft: "18px" }}>
                        {noChanges.map((err, idx) => (
                          <li key={idx}>
                            Row {err.row}: {err.error}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateItems;
